import moment from "moment";
import React from "react";
import { useIntl } from "react-intl";

import { useBookingFormPayment } from "shared/hooks/bookingFormPayment";
import { dayMonthYearFormat } from "shared/lib/datetime";

import Img from "@components/FileServer/Img";
import SetPaymentMethod from "@components/Result/SetPaymentMethod";
import FormattedMessage from "@components/UI/FormattedMessage";

type BookingFormPaymentDefinitionProps = {
  fullPrice: string;
};

export default function BookingFormPaymentDefinition({
  fullPrice,
}: BookingFormPaymentDefinitionProps) {
  const intl = useIntl();
  const {
    paymentFormMethods,
    alternativeCurrencyPaymentFormMethods,
    paymentTypeId,
    onSelectPayment,
    lastPaymentDate,
    defaultCountry,
    backgroundImageUrl,
  } = useBookingFormPayment(intl, fullPrice);

  return (
    <div className={backgroundImageUrl ? "result-form-box-wrapper" : ""}>
      <h3 className="h3 result-h3">
        <FormattedMessage id="Result.paymentAndDelivery" />
      </h3>
      <div className="result-form-box">
        <div className="result-payment-card-line">
          <Img
            src="/static/images/ico-card.svg"
            className="result-payment-card"
            alt="payment card icon"
          />
          <div className="result-payment-card-description">
            <FormattedMessage id="Result.reservationDeadline" />{" "}
            {moment(lastPaymentDate).format(dayMonthYearFormat(defaultCountry))}
          </div>
        </div>

        <SetPaymentMethod
          paymentFormMethods={
            alternativeCurrencyPaymentFormMethods || paymentFormMethods
          }
          paymentTypeId={paymentTypeId}
          onSelect={onSelectPayment}
        />
      </div>
    </div>
  );
}
